const TableTitle = ({ hideColumn }) => {
    return (
        <div className="d-none d-sm-none d-md-none d-lg-block">
            <div className="container-table-title">
                <div className="row vertical-align">
                    <div className="col">
                        <span><b>Portal B2B Cadena*</b></span>
                    </div>
                    <div className="col">
                        <span><b>Link portal B2B*</b></span>
                    </div>
                    <div className="col">
                        <span><b>Proveedor - Categoría (opcional)</b></span>
                    </div>
                    <div className="col">
                        <span><b>Usuario*</b></span>
                    </div>
                    <div className="col">
                            <span><b>Contraseña*</b></span>
                    </div>
                    {hideColumn !== false ? (
                        <div className="col">
                            <span><b>RUT o RUC Empresa</b></span>
                        </div>
                    ) : null}
                </div>
            </div>
        </div>
    );
};

export default TableTitle;
